<template>
  <div class="d-w100vw d-h100vh">
    <div class="d-of-hidden d-ps-absolute d-all0 gradient-container">
      <div class="gradient-title-area">
        <DialpadLogo class="logo-above" />
        <div class="gradient-container-wrapper">
          <BackgroundGradient />
        </div>
        <DialpadLogo class="logo-below logo-blended" />
        <DialpadLogo class="logo-below logo-overlay" />
      </div>

      <DtLink
        href="https://dialtone.dialpad.com"
        target="_blank"
        rel="noopener"
        class="d-link--no-underline d-ps-absolute d-b32 d-g8 d-mb1 d-fc-neutral-white dialtone-link-position"
      >
        Dialtone Design System
        <dt-icon-external-link size="200" />
      </DtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DtLink } from '@dialpad/dialtone/vue3';
import { DtIconExternalLink } from '@dialpad/dialtone-icons/vue';
import DialpadLogo from '@/components/DialpadLogo.vue';
import BackgroundGradient from '@/components/BackgroundGradient.vue';
</script>

<style lang="less">
// POSITION: both left-aligned on mobile; logo bottom-left / link bottom-right from the tablet breakpoint up
.logo-above,
.logo-below {
  position: absolute;
  top: var(--dt-spacing-400);
  left: var(--dt-spacing-400);
}

.dialtone-link-position {
  left: var(--dt-spacing-400);
}

@media (min-width: 640px) {
  .logo-above,
  .logo-below {
    top: auto;
    bottom: var(--dt-spacing-400);
  }

  .dialtone-link-position {
    left: auto;
    right: var(--dt-spacing-400);
  }
}

.logo-above {
  opacity: 0.7;
}

.logo-blended {
  mix-blend-mode: color-burn;
}
.logo-overlay {
  opacity: 0.2;
}

.gradient-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transform: translateZ(0);
}
</style>
